import { apiService } from '../ServiceApi';

export const wlmServices = apiService.injectEndpoints({
  endpoints: (builder) => ({
    // Ports GatewayMonitorWeb's WorkLoadFileSummary.do (file/trans set bucket summaries)
    getWorkLoadFileSummary: builder.query({
      query: (pData: { dataSource: string; timeInterval?: string }) => {
        return {
          method: 'POST',
          url: 'oncallapi/monitor/file-summary',
          params: {},
          body: {
            dataSource: pData?.dataSource,
            ...(pData?.timeInterval
              ? { timeInterval: pData.timeInterval }
              : {}),
          },
        };
      },
    }),
    // Ports GatewayMonitorWeb's CesTransactionSetInfo.do
    getCesTransactionSetInfo: builder.query({
      query: (dataSource: string) => {
        return {
          method: 'POST',
          url: 'oncallapi/monitor/ces-transaction-set-info',
          params: {},
          body: { dataSource },
        };
      },
    }),
    // Ports GatewayMonitorWeb's TransactionDetail.do, shown via the WLM "Detail" drill-down
    getWlmTransactionDetail: builder.query({
      query: (pData: {
        transSetId: string | number;
        bucket: string | number;
        dataSource: string;
      }) => {
        return {
          method: 'POST',
          url: 'oncallapi/monitor/transaction-detail',
          params: {},
          body: {
            transSetId: pData?.transSetId,
            bucket: pData?.bucket,
            dataSource: pData?.dataSource,
          },
        };
      },
    }),
  }),
});

export const {
  useGetWorkLoadFileSummaryQuery,
  useGetCesTransactionSetInfoQuery,
  useGetWlmTransactionDetailQuery,
} = wlmServices;
